var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { colors, fontWeight, zIndex } from "core/styles/snippets";
import { Id } from "core/utils";
import Countdown from "hero/components/Countdown";
import React from "react";
import styled from "styled-components";
var AffixedCountdown = function (_a) {
    var className = _a.className, duration = _a.duration, prefix = _a.prefix, suffix = _a.suffix;
    return (React.createElement(Container, { "data-component": Id.component.dynamicHeroAffixedCountdown, className: className },
        prefix && React.createElement(Affix, { kind: "pre" }, prefix),
        React.createElement(Countdown, { duration: duration }),
        suffix && React.createElement(Affix, { kind: "suf" }, suffix)));
};
export default AffixedCountdown;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  color: ", ";\n"])), colors.white);
var Affix = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  font-size: 1.125rem;\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  font-size: 1.125rem;\n  ", ";\n  ", ";\n"])), zIndex.pulsarAffix, fontWeight.bold, function (_a) {
    var kind = _a.kind;
    return kind === "pre" ? "margin-right: 0.5rem;" : "margin-left: 0.5rem;";
});
var templateObject_1, templateObject_2;
